import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { I18nModule } from '@spartacus/core'
import { FormErrorsModule } from '@spartacus/storefront'
import { CustomComponentsModule } from '../../../../shared/custom-components/custom-components.module'
import { PriceAgreementAcceptComponent } from './price-agreement-accept/price-agreement-accept.component'
import { PriceAgreementRejectComponent } from './price-agreement-reject/price-agreement-reject.component'

@NgModule({
  declarations: [PriceAgreementAcceptComponent, PriceAgreementRejectComponent],
  imports: [CommonModule, FormErrorsModule, ReactiveFormsModule, I18nModule, CustomComponentsModule]
})
export class PriceAgreementAcceptRejectModule {}
